import { createActionGroup } from '@ngrx/store';

export const OrganisationNewsletterActions = createActionGroup({
  source: 'Organisation Newsletter',
  events: {}
});
